import React from 'react';
import useCart from '@/store/shopping';
import { WeeeIcon } from '../Icon';
import { twMerge } from 'tailwind-merge';
import { isSayWeeeApp } from '@/utils/weeeapp';
import { buildUrlWithOrigin } from '@/utils/url';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { isMobile } from '@/utils/common/device';

type MiniCartProps = {
  icon?: any;
  className?: string;
  countClassName?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  iconClassName?: string;
  iconStyle?: React.CSSProperties;
};

function MiniCartIcon(props: MiniCartProps) {
  const { icon, className, countClassName, style, onClick, iconClassName, iconStyle } = props;
  const { count } = useCart();
  const router = useRouter();
  const { t, lang } = useTranslation('common');

  const handleClick = () => {
    onClick?.();
    if (isSayWeeeApp() || !isMobile()) {
      window.location.href = buildUrlWithOrigin(`/${lang}/cart`);
      return;
    }
    router.push('/cart');
  };

  return (
    <div
      data-testid="btn-mini-cart"
      aria-label={t('my_cart')}
      role="button"
      style={style}
      onClick={handleClick}
      className={twMerge(
        'relative box-border w-1000 h-1000 flex justify-center items-center border-2 border-solid border-surface-100-hairline rounded-full',
        className
      )}>
      {!!count && count > 0 && (
        <span
          className={twMerge(
            'absolute box-border -top-0.5 right-0 translate-x-[40%] h-[20px] min-w-[22px] px-1 flex items-center justify-center text-reserved-true-white rounded-full bg-pricing-bg enki-body-2xs-strong',
            countClassName
          )}>
          {count > 999 ? '999+' : count}
        </span>
      )}
      {icon ? (
        icon
      ) : (
        <WeeeIcon
          aria-label={t('my_cart')}
          role="button"
          style={{ fontSize: 18, ...iconStyle }}
          type="iconIcon"
          className={iconClassName}
        />
      )}
    </div>
  );
}

export default MiniCartIcon;
